import styled, { css } from '../../styled';
import Text from '../text';
const Description = styled(Text) `
  display: block;
  margin-top: 0.25rem;
`;
const Title = styled(Text) `
  display: block;
  margin-top: 0.75rem;
  color: ${({ theme, disabled }) => disabled ? theme.colors.INK_400 : theme.colors.INK_600};
`;
const ContentWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  position: relative;
`;
const errorStyles = css `
  background-color: ${({ theme }) => theme.colors.RED_200};
  border-color: ${({ theme }) => theme.colors.RED_700};
  ${Title}, ${Description} {
    color: ${({ theme }) => theme.colors.RED_700};
  }
  > div > svg {
    fill: ${({ theme }) => theme.colors.RED_700};
  }
`;
const hoverStyles = css `
  :hover {
    background-color: ${({ theme }) => theme.colors.PRIMARY_200};
    border-color: ${({ theme }) => theme.colors.PRIMARY_400};
    ${Title}, ${Description} {
      color: ${({ theme }) => theme.colors.PRIMARY_600};
    }
    > div > svg {
      fill: ${({ theme }) => theme.colors.PRIMARY_600};
    }
  }
`;
const loadingStyles = css `
  pointer-events: none;
`;
const IconWrapper = styled.button `
  border: none;
  outline: none;
  padding: 0.75rem;
  display: flex;
  justify-contents: center;
  align-items: center;
  background-color: transparent;
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
  :hover {
    background-color: ${({ theme }) => theme.colors.PRIMARY_200};

    > svg {
      fill: ${({ theme }) => theme.colors.RED_600};
    }
  }
`;
const ImageUploadWrapper = styled.div `
  height: 100%;
  background-color: ${({ theme, disabled }) => disabled ? theme.colors.SNOW_300 : theme.colors.SNOW_100};
  border: 1px dashed ${({ theme }) => theme.colors.INK_300};
  border-radius: 0.25rem 0.25rem 0 0;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  & svg {
    fill: ${({ theme, disabled }) => disabled ? theme.colors.INK_400 : 'inherit'};
  }
  ${({ isLoading }) => isLoading && loadingStyles}
  ${({ isError }) => (isError ? errorStyles : hoverStyles)}
`;
const ImageUploadZoneWrapper = styled.div `
  box-sizing: border-box;
  width: ${({ width }) => (width ? `${width}rem` : '100%')}
  height: ${({ height }) => (height ? `${height}rem` : '100%')}
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  > div {
    height: 100%;
  }
`;
const ImagePreview = styled.div `
  background-image: ${({ imageSource, isLoading }) => isLoading ? 'none' : `url(${imageSource})`};
  width: 100%;
  height: 100%;
  border-radius: 0.25rem 0.25rem 0 0;
  background-position: center;
  background-size: cover;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  > div {
    display: none;
  }

  :hover {
    cursor: pointer;

    > div {
      display: flex;
      background-color: ${({ theme }) => theme.colors.SNOW_A900};
    }
  }
`;
export { ContentWrapper, Description, IconWrapper, ImagePreview, ImageUploadWrapper, ImageUploadZoneWrapper, Title, };
//# sourceMappingURL=LayoutComponents.js.map